import { appStorage } from "@miview/utils";

export const getUserLanguagePreference = async () => {
  const user = await appStorage.getItem("user");
return JSON.parse(user)?.language;
};
